import React from 'react'
import PropTypes from 'prop-types'

import './panel.css'

import Logo from './../../static/images/logo.svg'

const Panel = ({featurePanel, mainPanel}) => {
  return (
    <div className='panel-wrapper'>
      {featurePanel &&
        <div className='feature-panel feature-panel--enterprise is-hidden-touch'>
          <div className='enterprise-panel__content'>
            <h2 className='enterprise-panel__header'>
              <img src={Logo} alt='Companhia.Edu - logo' />
            </h2>
          </div>
        </div>
      }

      <div className='main-panel'>
        <div className='main-panel__content'>
          {mainPanel}
        </div>
      </div>

    </div>
  )
}

Panel.propTypes = {
  featurePanel: PropTypes.bool
}

export default Panel



// WEBPACK FOOTER //
// ./src/components/Panel/index.js